import type { GfMaterialDetail, GfMaterialItem } from '../types';

/**
 * コマ詳細（GfMaterialDetail）を一覧アイテム（GfMaterialItem）へ変換する。
 * SNS 共有 / URL 直開きで一覧を経由せず詳細だけ持っているコマを、前後送りの初期の並び（1 件目）
 * として載せるために使う。前後のコマは API で読み足す。
 */
export function materialDetailToItem(detail: GfMaterialDetail): GfMaterialItem {
  return {
    id: detail.id,
    materialCode: detail.materialCode,
    materialType: detail.categoryName,
    name: detail.name,
    nameKana: detail.nameKana,
    description: detail.description,
    thumbnailPath: detail.thumbnailPath,
    dpi: detail.dpi,
    additionalTaxExcludedPrice: detail.additionalTaxExcludedPrice,
    displayOrder: detail.displayOrder,
    badgeStatus: detail.badgeStatus ?? '',
    tags: detail.tags,
    isFavorite: detail.isFavorite,
    work: { id: detail.work.id, name: detail.work.name },
    createdAt: detail.createdAt,
    updatedAt: detail.updatedAt,
  };
}
